import { fg } from '@confluence/feature-gating';

import { useIsDataClassificationEnabledForOrg } from './useIsDataClassificationEnabledForOrg';

const isContentTypeApplicable = (contentType: string, isLivePage: boolean = false) => {
	if (contentType === 'page' && isLivePage) return true;
	return ['whiteboard', 'database'].includes(contentType);
};

export const useIsClassificationEnabledForContentTypeExpansion = (
	contentType: string,
	isLivePage: boolean = false,
): boolean => {
	const { isEnabled: isClassificationEnabledForOrg } = useIsDataClassificationEnabledForOrg();

	// when object header is enabled, it's enabled for all content types
	return (
		(fg('confluence_frontend_object_header') || isContentTypeApplicable(contentType, isLivePage)) &&
		isClassificationEnabledForOrg
	);
};
